import type { ReactNode, CSSProperties } from 'react';

export interface CardProps {
  title?: string;
  subtitle?: string;
  action?: ReactNode;
  padded?: boolean;
  /**
   * When the card is itself a flex column (e.g. a chat pane with a scrolling
   * message list + a pinned input row), the children must become direct flex
   * items. `fill` drops the body wrapper from layout (display:contents) so the
   * children's flex:1 / flexShrink:0 anchor to the card's height — pinning the
   * input row to the bottom.
   */
  fill?: boolean;
  children?: ReactNode;
  style?: CSSProperties;
  className?: string;
}

export function Card({
  title,
  subtitle,
  action,
  padded = true,
  fill = false,
  children,
  style,
  className = '',
}: CardProps) {
  return (
    <div className={`card ${className}`} style={style}>
      {(title || subtitle || action) && (
        <div
          className="row"
          style={{
            justifyContent: 'space-between',
            padding: 'var(--pad-card) var(--pad-card) 4px',
          }}
        >
          <div>
            {title && (
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, letterSpacing: -0.2 }}>{title}</h3>
            )}
            {subtitle && (
              <p style={{ margin: '2px 0 0', color: 'var(--muted)', fontSize: 'var(--t-xs)' }}>
                {subtitle}
              </p>
            )}
          </div>
          {action}
        </div>
      )}
      <div style={fill ? { display: 'contents' } : padded ? { padding: 'var(--pad-card)' } : {}}>{children}</div>
    </div>
  );
}
